var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28223 0H5.92508V1.64286H4.28223V0Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8545 0H12.4973V1.64286H10.8545V0Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63965 1.64258H4.28251V3.28544H2.63965V1.64258Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92676 1.64258H7.56962V3.28544H5.92676V1.64258Z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21191 1.64258H10.8548V3.28544H9.21191V1.64258Z",
    fill: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4971 1.64258H14.1399V3.28544H12.4971V1.64258Z",
    fill: ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56738 3.28516H9.21024V6.57087H7.56738V3.28516Z",
    fill: ""
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28223 4.92773H5.92508V6.57059H4.28223V4.92773Z",
    fill: ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8545 4.92871H12.4973V6.57157H10.8545V4.92871Z",
    fill: ""
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63965 6.57129H4.28251V9.857H2.63965V6.57129Z",
    fill: ""
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92676 6.57227H7.56962V8.21512H5.92676V6.57227Z",
    fill: ""
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21191 6.57227H10.8548V8.21512H9.21191V6.57227Z",
    fill: ""
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4971 6.57129H14.1399V9.857H12.4971V6.57129Z",
    fill: ""
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56738 8.21484H9.21024V11.5006H7.56738V8.21484Z",
    fill: ""
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4256 8.21484H19.0685V11.5006H20.7114V9.8577H23.9971V11.5006H22.3542V13.1434H20.7114V18.072H22.3542V21.3577H23.9971V24.6434H17.4256V23.0006H15.7828V21.3577H14.1399V19.7148H5.92564V21.3577H4.28278V23.0006H2.63993V24.6434H0.99707V16.4291H2.63993V14.7863H4.28278V13.1434H15.7828V14.7863H17.4256V8.21484Z",
    fill: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.28223 16.4277H5.92508V18.0706H4.28223V16.4277Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4971 16.4287H14.1399V18.0716H12.4971V16.4287Z",
    fill: ""
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56738 21.3574H9.21024V24.6431H7.56738V21.3574Z",
    fill: ""
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8545 21.3574H12.4973V24.6431H10.8545V21.3574Z",
    fill: ""
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28223 23H5.92508V24.6429H4.28223V23Z",
    fill: ""
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1396 23H15.7825V24.6429H14.1396V23Z",
    fill: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWale);
export default __webpack_public_path__ + "static/media/wale.fc1731be.svg";
export { ForwardRef as ReactComponent };